// extracted by mini-css-extract-plugin
export var filterIncDec = "_fa-0";
export var leftBorder = "_fa-1";
export var rightBorder = "_fa-2";
export var stringInput = "_fa-3";